export default __webpack_public_path__ + "b4706f4d94968d00b8ce951dc2dc31f9.png";